var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("label", [_vm._v("มูลค่างาน(บาท)")]),
          _c("vue-numeric", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { max_value: _vm.checkMiddlePrice },
                expression: "{ max_value:checkMiddlePrice }"
              }
            ],
            staticClass: "form-control",
            class: { input: true, "is-danger": _vm.errors.has("jobPrice") },
            attrs: {
              separator: ",",
              precision: 2,
              name: "jobPrice",
              placeholder: "กรุณากรอกจำนวน",
              "data-vv-as": "มูลค่างาน",
              disabled: this.reqType !== 1
            },
            model: {
              value: _vm.jobPrice,
              callback: function($$v) {
                _vm.jobPrice = $$v
              },
              expression: "jobPrice"
            }
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("jobPrice"),
                  expression: "errors.has('jobPrice')"
                }
              ],
              staticClass: "help is-danger"
            },
            [_vm._v(_vm._s(_vm.errors.first("jobPrice")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("label", [_vm._v("ราคากลาง(บาท)")]),
          _c("vue-numeric", {
            staticClass: "form-control",
            class: { input: true, "is-danger": _vm.errors.has("middlePrice") },
            attrs: {
              separator: ",",
              precision: 2,
              name: "middlePrice",
              placeholder: "กรุณากรอกจำนวน",
              "data-vv-as": "ราคากลาง",
              disabled: this.reqType !== 1
            },
            model: {
              value: _vm.middlePrice,
              callback: function($$v) {
                _vm.middlePrice = $$v
              },
              expression: "middlePrice"
            }
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("middlePrice"),
                  expression: "errors.has('middlePrice')"
                }
              ],
              staticClass: "help is-danger"
            },
            [_vm._v(_vm._s(_vm.errors.first("jobPrice")))]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("มูลค่างานตามสัญญา \n        ")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }